// src/features/receipts/insuranceReceiptThunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getDebitorRcvWithDetailsApi,
  getDebitorReciptCodeApi,
  getDueEmisApi,
  getDueSalesVoucherApi,
  getSundryDebitorInsuranceBalanceApi,
  saveDebitorReciptApi,
  deleteDebitorReciptApi,
} from "../../apiservice/accounts";
import { getAccountByTypeApi } from "../../apiservice/setting";
import { getCustomers } from "../../services/customer";

// fetch receipts list
export const fetchInsuranceReceipts = createAsyncThunk(
  "insuranceReceipts/fetchInsuranceReceipts",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getDebitorRcvWithDetailsApi({ oneDate: null });
      // filter for Insurance type (like original file)
      const filtered = (res.data || []).filter((item) => item.details && item.details[0].debitor_type === "Insurance");
      return filtered;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// receipt code
export const fetchInsuranceReceiptCode = createAsyncThunk(
  "insuranceReceipts/fetchInsuranceReceiptCode",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getDebitorReciptCodeApi(null);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// due vouchers
// accept param object: { insuranceId, customerId } (insuranceId optional)
export const fetchInsuranceDueVouchers = createAsyncThunk(
  "insuranceReceipts/fetchInsuranceDueVouchers",
  async ({ insuranceId = 0, customerId = 0 }, { rejectWithValue }) => {
    try {
      const res = await getDueSalesVoucherApi({ insuranceId, customerId });
      // backend returns array; we'll index by customerId if provided
      return { customerId, vouchers: res.data };
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// due EMIs (by customerId)
export const fetchInsuranceDueEmis = createAsyncThunk(
  "insuranceReceipts/fetchInsuranceDueEmis",
  async (customerId, { rejectWithValue }) => {
    try {
      const res = await getDueEmisApi({ customerId });
      return { customerId, emis: res.data };
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// customer insurance balance
export const fetchInsuranceCustomerBalance = createAsyncThunk(
  "insuranceReceipts/fetchInsuranceCustomerBalance",
  async (customerId, { rejectWithValue }) => {
    try {
      const res = await getSundryDebitorInsuranceBalanceApi({ customerId });
      return { customerId, balance: res.data.total_balance };
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// save receipt
export const saveInsuranceReceipt = createAsyncThunk(
  "insuranceReceipts/saveInsuranceReceipt",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await saveDebitorReciptApi(payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// delete
export const deleteInsuranceReceipt = createAsyncThunk(
  "insuranceReceipts/deleteInsuranceReceipt",
  async (rcv_id, { rejectWithValue }) => {
    try {
      const res = await deleteDebitorReciptApi({ rcv_id });
      return { id: rcv_id, msg: res.data.msg };
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// fetch direct expense account (for discount mapping)
export const fetchInsuranceDirectExpenseAccounts = createAsyncThunk(
  "insuranceReceipts/fetchInsuranceDirectExpenseAccounts",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getAccountByTypeApi({ acc_type_id: "direct_expense" });
      return res.data[0];
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchCustomerList = createAsyncThunk(
  "salesPharma/fetchCustomerList",
  async (searchValue, { rejectWithValue }) => {
    try {
      const response = await getCustomers({
        query: searchValue.trim(),
        type: "debitor",
        acc_type_name: ["Customer", "patient"],
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
